// extracted by css-extract-rspack-plugin
export default {"monthsList":"hau5a"};